var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TheHeader'),_c('main',{attrs:{"id":"main"}},[_c('NewsletterPopup'),_c('FloatingWhatsapp',{attrs:{"phone":"5588997910019"}}),_c('transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }